import { SimpleGrid, Stack, Text } from "@mantine/core";
import { IconFile } from "@tabler/icons-react";
import classes from "./TravellerPolicyDrawer.module.css";

const DOC_ITEMS = [
  { key: "passport_front", label: "Passport Front" },
  { key: "passport_back", label: "Passport Back" },
  { key: "aadhar_card_front", label: "Aadhar Front" },
  { key: "aadhar_card_back", label: "Aadhar Back" },
  { key: "flight_ticket", label: "Flight Ticket" },
  { key: "cover_document", label: "Cover Document" },
  { key: "residence_proof", label: "Residence Proof" },
  { key: "kyc_document", label: "KYC Document" },
  { key: "medical_form", label: "Medical Form" },
];

const TravellerDrawerDocuments = ({ traveller }) => {
  if (!traveller) return null;
  const available = DOC_ITEMS.filter((item) => traveller[item.key]);

  if (!available.length) {
    return <Text size="sm" c="dimmed">No documents uploaded.</Text>;
  }

  return (
    <Stack gap="md">
      <SimpleGrid cols={{ base: 2, sm: 3 }} spacing="sm">
        {available.map((item) => (
          <a
            key={item.key}
            href={traveller[item.key]}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.docCard}
          >
            <IconFile size={28} color="#6C94B4" />
            <Text size="sm" fw={600} mt={8} className={classes.docLabel}>{item.label}</Text>
          </a>
        ))}
      </SimpleGrid>
      <Text size="xs" c="dimmed">Click any document to view or download.</Text>
    </Stack>
  );
};

export default TravellerDrawerDocuments;
